import { ILocalAccount } from '@src/models/account';

export const getAccountNotificationName = (account?: ILocalAccount) => {
  if (!account) return '';
  const { email, lastName, firstName } = account;

  let result = '';

  if (firstName) {
    result += firstName;
  }

  if (lastName) {
    result += ` ${lastName}`;
  }

  if (email) {
    result += ` ${email}`;
  }

  return result;
};
